import styled from 'styled-components'
import { BrandLogo } from '../BrandLogo/BrandLogo'

export const Container = styled.div<{
  hasShadow?: boolean
  offsetHeight?: number
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100%;
  height: 57rem;
  padding: 0 2rem;
  background-color: ${({ theme }) => theme.colors.border};

  @media (min-width: 768px) {
    height: 75rem;
  }

  @media (min-width: 992px) {
    height: 63rem;
    padding: 0 4rem;
  }

  @media (min-width: 1200px) {
    height: 98vh;
  }

  ${BrandLogo.Extended} {
    width: 50%;
    height: auto;
  }
`
